import React from "react";
import options from "../config/districtOfficeOptions";

let orgSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let org = queryParams.org === undefined ? "" : queryParams.org;

  return (
    <div title="Choose a USACE Division or District" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Filter by District:
      </div>
      <div className="tableItem">
        <select
          id="org"
          value={org}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

let yearSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let thisYear = new Date().getFullYear();
  let year = queryParams.year === undefined ? "ALL" : queryParams.year;
  return (
    <div title="Choose a specific year or all years" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Year:
      </div>
      <div className="tableItem">
        <select
          id="year"
          value={year}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="ALL">All Years</option>
          {Array.apply(null, { length: 10 }).map(function (obj, i) {
            let theYear = thisYear - parseInt(i);
            return (
              <option value={theYear.toString()} id={theYear.toString()}>
                {theYear}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

let monthSelect = function (onChange, queryParams, labelwidth) {
  let lw = labelwidth === undefined ? "inherit" : labelwidth.toString() + "px";
  let month = queryParams.month === undefined ? "0" : queryParams.month;
  return (
    <div title="Choose a month or Year to Date" className="tableItem">
      <div className="tableItem" style={{ width: lw }}>
        Month:
      </div>
      <div className="tableItem">
        <select
          id="month"
          value={month}
          style={{ marginRight: "0px" }}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="0">Year to Date</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>
    </div>
  );
};

let eventSelect = function (onChange, queryParams, events, labelwidth) {
  let lw = labelwidth === undefined ? 0 : labelwidth;
  let event = queryParams.event === undefined ? "" : queryParams.event;
  let wkEvents = events === null ? [] : events;
  return (
    <div className="tableItem">
      <div className="tableItem" style={lw > 0 ? {} : { width: lw }}>
        Filter by Event:
      </div>
      <div className="tableItem">
        <select
          id="event"
          value={event}
          className="selectlist"
          size="1"
          onChange={onChange}
        >
          <option value="" selected="selected">
            All Events
          </option>
          {wkEvents.map(function (obj, i) {
            return <option value={obj}>{obj}</option>;
          })}
        </select>
      </div>
    </div>
  );
};

export { orgSelect, yearSelect, monthSelect, eventSelect };
